
const observer = new MutationObserver(() => {
  const cards = document.querySelectorAll(".ServicesList__Card-sc-u6utj6-1");

  if (!cards.length) return;

  cards.forEach(card => {
    const title = card.querySelector("h3");
    if (!title) return;

    const text = title.textContent.trim().toLowerCase();

    if (text.includes("15-minute starter kit")) card.id = "starter-kit";
    if (text.includes("new client nutrition")) card.id = "new-client";
    if (text.includes("complex health")) card.id = "complex-health";
    if (text.includes("virtual home cooking")) card.id = "virtual-home-cooking";
    if (text.includes("kids in the kitchen")) card.id = "kids-kitchen";
  });

  if (location.hash) {
    const target = document.querySelector(location.hash);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  }

  observer.disconnect();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


(function () {
  'use strict';

  /* -------- config -------- */
  var TEST_MODE = true;                    // false on live store
  var GIFT_VARIANT_ID = 59612722331729;    // 16 oz Lamb Bone Marrow Stock
  var TRIGGER_PRODUCT_IDS = [
    15938006417489,                        // Chicken & Greens
    15938043740241                         // Salmon & Greens
  ];
  var GIFT_FLAG = '_free_marrow_stock';
  var PENDING_KEY = 'marrow_gift_pending';
  /* ------------------------ */

  function debug() {
    if (TEST_MODE && window.console) {
      console.log.apply(console, ['[marrow-gift]'].concat([].slice.call(arguments)));
    }
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function giftLines(cart) {
    return cart.items.filter(function (i) {
      return i.variant_id === GIFT_VARIANT_ID && i.properties && i.properties[GIFT_FLAG];
    });
  }
  function hasFormula(cart) {
    return cart.items.some(function (i) {
      return TRIGGER_PRODUCT_IDS.indexOf(i.product_id) !== -1;
    });
  }
  function customerAddedStock(cart) {
    return cart.items.some(function (i) {
      return i.variant_id === GIFT_VARIANT_ID && !(i.properties && i.properties[GIFT_FLAG]);
    });
  }

  function getPending() { try { return sessionStorage.getItem(PENDING_KEY); } catch (e) { return null; } }
  function setPending(v) { try { sessionStorage.setItem(PENDING_KEY, v || '1'); } catch (e) {} }
  function clearPending() { try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {} }

  /* Pre-paint shield so the gift is never visible during cleanup. */
  var shieldTimer = null;
  function shieldOn() {
    document.documentElement.style.visibility = 'hidden';
    clearTimeout(shieldTimer);
    shieldTimer = setTimeout(shieldOff, 3000);
  }
  function shieldOff() {
    clearTimeout(shieldTimer);
    document.documentElement.style.visibility = '';
  }

  /* Returning from checkout: clean the gift out before showing anything. */
  var resolving = false;
  function resolveReturnFromCheckout() {
    if (!getPending() || resolving) return false;
    resolving = true;
    debug('back from checkout with gift pending - cleaning before showing the page');
    shieldOn();
    getCart().then(function (cart) {
      var lines = giftLines(cart);
      if (!lines.length) {
        debug('gift no longer in cart (order placed or already removed)');
        clearPending();
        shieldOff();
        resolving = false;
        return;
      }
      return post('/cart/change.js', { id: lines[0].key, quantity: 0 }).then(function (r) {
        clearPending();
        resolving = false;
        if (r.ok) { location.reload(); } else { shieldOff(); }
      });
    }).catch(function () {
      clearPending();
      resolving = false;
      shieldOff();
    });
    return true;
  }

  /* Backup sweep for stray gift lines. */
  function cleanup() {
    if (getPending() || resolving) return;
    getCart().then(function (cart) {
      var lines = giftLines(cart);
      if (!lines.length) return;
      debug('cleanup: removing stray gift line');
      return post('/cart/change.js', { id: lines[0].key, quantity: 0 }).then(function (r) {
        if (r.ok) location.reload();
      });
    }).catch(function () {});
  }

  /* Add the gift only at the moment of going to checkout. */
  var busy = false;
  function addThenCheckout(dest) {
    if (busy) return;
    busy = true;
    dest = dest || '/checkout';

    getCart().then(function (cart) {
      var existing = giftLines(cart);
      if (!hasFormula(cart) || existing.length || customerAddedStock(cart)) {
        if (existing.length) setPending(existing[0].key);
        debug('no add needed - going to checkout');
        window.location.href = dest;
        return;
      }
      debug('adding the free stock, then checkout...');
      var props = {};
      props[GIFT_FLAG] = '1';
      return post('/cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: props }] })
        .then(function (r) {
          if (!r.ok) {
            debug('add failed, status', r.status, '- continuing without the gift');
            window.location.href = dest;
            return;
          }
          return getCart().then(function (c2) {
            var line = giftLines(c2)[0];
            if (line) debug('gift price at handoff (cents):', line.final_line_price);
            if (line && line.final_line_price !== 0 && !TEST_MODE) {
              debug('discount not active - removing gift before checkout');
              return post('/cart/change.js', { id: line.key, quantity: 0 })
                .then(function () { window.location.href = dest; });
            }
            if (line) setPending(line.key);
            window.location.href = dest;
          });
        });
    }).catch(function () {
      window.location.href = dest;
    }).then(function () { busy = false; });
  }

  /* Intercept every way the theme goes to checkout:
     links, named buttons, AND inline onclick redirects (the popup button). */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [onclick*="/checkout"]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    debug('checkout click intercepted');
    addThenCheckout(t.tagName === 'A' && t.href ? t.href : '/checkout');
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && String(f.action).indexOf('/checkout') !== -1) {
      e.preventDefault();
      debug('checkout form intercepted');
      addThenCheckout('/checkout');
    }
  }, true);

  debug('script loaded (checkout-time mode). triggers:', TRIGGER_PRODUCT_IDS, '| gift:', GIFT_VARIANT_ID);

  if (!resolveReturnFromCheckout()) {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(cleanup, 200); });
  }
  window.addEventListener('pageshow', function () {
    if (!resolveReturnFromCheckout()) setTimeout(cleanup, 300);
  });
})();


(function () {
  var byTitle = null;
  var LB_TO_OZ = { 4: 16, 8: 32, 16: 64 };
  var STOCK_BY_OZ = { 16: 1, 32: 2, 64: 4 };

  function load() {
    var el = document.querySelector('.skw [data-skw-variants]');
    if (!el) return false;
    var map = {};
    try {
      JSON.parse(el.textContent).forEach(function (v) {
        map[(v.title || '').trim()] = v;
      });
    } catch (e) { return false; }
    byTitle = map;
    return true;
  }

  function paint() {
    var card = document.querySelector('.skw');
    if (!card) return;
    if (!byTitle && !load()) return;

    var parts = [];
    document.querySelectorAll('select.single-option-selector').forEach(function (s) {
      if (card.contains(s)) return;
      var val = (s.value || '').trim();
      if (val) parts.push(val);
    });

    var v = byTitle[parts.join(' / ')];
    if (!v) return;

    var m = v.title.match(/(\d+)\s*(lb|oz)/i);
    if (!m) return;
    var n = parseInt(m[1], 10);
    var oz = m[2].toLowerCase() === 'lb' ? (LB_TO_OZ[n] || n) : n;

    card.querySelectorAll('[data-skw-food]').forEach(function (fe) {
      var txt = (fe.getAttribute('data-count') || '4') + ' x ' + oz + ' oz';
      if (fe.textContent !== txt) fe.textContent = txt;
    });

    if (card.getAttribute('data-scale-stock') === 'true') {
      var st = card.querySelector('[data-skw-stock]');
      if (st) {
        var sv = String(STOCK_BY_OZ[oz] || 1);
        if (st.textContent !== sv) st.textContent = sv;
      }
    }

    var f = card.querySelector('[data-skw-formula]');
    if (f && v.title.indexOf(' / ') !== -1) {
      var p = v.title.split(' / ')[0].trim();
      if (f.textContent !== p) f.textContent = p;
    }
  }

  setInterval(paint, 300);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
})();



 